import axios from "axios";
import { CreateEventPayload, EventSettingPayload, GetEventBlocksPayload, GetUserEventsPayload } from "../types/event.types";
import { axiosInstance } from "./axios";

export const updateEventSettings = async (eventId: string, eventSettingPayload: EventSettingPayload) => {
  try {
    return await axiosInstance.put(`event/${eventId}/settings`, eventSettingPayload);
  } catch (error) {
    throw error;
  }
};

export const getEventBlocks = async (eventId: string, eventBlocksPayload: GetEventBlocksPayload) => {
  try {
    return await axiosInstance.post(`event/${eventId}/blocks`, eventBlocksPayload);
  } catch (error) {
    throw error;
  }
};

export const getUserEvents = async (getUserEventsPayload: GetUserEventsPayload) => {
  try {
    return await axiosInstance.post(`event/get-user-events`, getUserEventsPayload);
  } catch (error) {
    throw error;
  }
};

export const getEventTaskList = async (eventId: string, blockId: string, cardId: string) => {
  try {
    return await axiosInstance.get(`event/${eventId}/get-task-list/${blockId}/${cardId}`);
  } catch (error) {
    throw error;
  }
}

export const updateTask = async (eventId: string, payLoad: any) => {
  try {
    return await axiosInstance.put(`event/${eventId}/update-task`, payLoad);
  } catch (error) {
    throw error;
  }
}

export const createEvent = async (createEventPayload: CreateEventPayload) => {
  try {
    return await axiosInstance.post(`event`, createEventPayload);
  } catch (error) {
    throw error;
  }
};

export const recentActivities = async (teamId: any) => {
  try {
    return await axiosInstance.get(`event/recent-activities/${teamId}`);
  } catch (error) {
    throw error;
  }
};

export const updatePositions = async (eventId: any, payLoad: any) => {
  try {
    return await axiosInstance.put(`event/${eventId}/update-positions`, payLoad);
  } catch (error) {
    throw error;
  }
}

export const updateEvent = async (eventId: string, updateEventPayload: any) => {
  try {
    return await axiosInstance.put(`event/${eventId}`, updateEventPayload);
  } catch (error) {
    throw error;
  }
};

export const getEventTasks = async (eventId: string) => {
  try {
    return await axiosInstance.get(`event/${eventId}/get-all-tasks`);
  } catch (error) {
    throw error;
  }
}

export const getInsightData = async (eventId: any, payload: any) => {
  try {
    return await axiosInstance.post(`event/${eventId}/insights`, payload);
  } catch (error) {
    throw error;
  }
}

export const sendEmails = async (eventId: any, payload: any) => {
  try {
    return await axiosInstance.post(`event/${eventId}/send-emails`, payload);
  } catch (error) {
    throw error;
  }
}

export const markEventAsFavorite = async (eventId: any, payload: any) => {
  try {
    return await axiosInstance.put(`event/${eventId}/mark-favorite`, payload);
  } catch (error) {
    throw error;
  }
}

export const getFavoriteEvents = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/favorite-events`, payload);
  } catch (error) {
    throw error;
  }
}

export const getHistoryFilters = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/history-filters`, payload);
  } catch (error) {
    throw error;
  }
}

export const getHistoryData = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/history`, payload);
  } catch (error) {
    throw error;
  }
}

export const addHistoryData = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/add-history`, payload);
  } catch (error) {
    throw error;
  }
}

export const addFileHistoryData = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/add-file-history`, payload);
  } catch (error) {
    throw error;
  }
}

export const getAllBlocks = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/get-all-blocks`, payload);
  } catch (error) {
    throw error;
  }
}

export const getFavoriteContent = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/favorite-content`, payload);
  } catch (error) {
    throw error;
  }
}

export const getNextBestActionsData = async () => {
  try {
    return await axiosInstance.get(`event/next-best-actions`);
  } catch (error) {
    throw error;
  }
};

export const getBudgetAllocationData = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/get-budget-allocation`, payload);
  } catch (error) {
    throw error;
  }
};

export const checkTaskAllocation = async (eventId: any, payload: any) => {
  try {
    return await axiosInstance.post(`event/${eventId}/task-allocation`, payload);
  } catch (error) {
    throw error;
  }
};

export const getAttendeeList = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/attendees`, payload);
  } catch (error) {
    throw error;
  }
}

export const resendEmails = async (eventId: any, payload: any) => {
  try {
    return await axiosInstance.post(`event/${eventId}/resend-emails`, payload);
  } catch (error) {
    throw error;
  }
}

export const getDefaultBudgetValues = async (eventId: any) => {
  try {
    return await axiosInstance.post(`event/default-budget-allocation/${eventId}`, {});
  } catch (error) {
    throw error;
  }
}

export const getEventImage = async (id: any) => {
  try {
    return await axiosInstance.post(`event/${id}/image-generate`, { id });
  } catch (error) {
    throw error;
  }
}

export const getDocumentForComparison = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/document-comparison`, payload);
  } catch (error) {
    throw error;
  }
}

export const fileUploadExtraction = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/file-upload-extraction`, payload);
  } catch (error) {
    throw error;
  }
}

export const listData = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/list-data`, payload);
  } catch (error) {
    throw error;
  }
}

export const getFileContent = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/get-file-content`, payload);
  } catch (error) {
    throw error;
  }
}
export const getVenueDetails = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/venue-details`, payload);
  } catch (error) {
    throw error;
  }
}

export const getEventVendorList = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/vendor-list`, payload);
  } catch (error) {
    throw error;
  }
}

export const deleteAttendees = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/delete-attendees`, payload);
  } catch (error) {
    throw error;
  }
}

export const fileUploadList = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/file-upload-list`, payload);
  } catch (error) {
    throw error;
  }
}

export const updateAttendee = async (id: any, payload: any) => {
  try {
    return await axiosInstance.put(`event/update-attendee/${id}`, payload);
  } catch (error) {
    throw error;
  }
}

export const addAttendeeFromList = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/add-attendee-from-list`, payload);
  } catch (error) {
    throw error;
  }
}

export const downloadData = async (payload: any) => {
  try {
    return await axiosInstance.post<string, Blob>(`event/download-data`, payload, { responseType: 'blob' });
  } catch (error) {
    throw error;
  }
}

export const changeEventImage = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/change-image`, payload);
  } catch (error) {
    throw error;
  }
}

export const getSampleImages = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/sample-images`, payload);
  } catch (error) {
    throw error;
  }
}

export const deleteFete = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/delete-fete`, payload);
  } catch (error) {
    throw error;
  }
}

export const updateVenue = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/update-venue`, payload);
  } catch (error) {
    throw error;
  }
}

export const getRFPCategories = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/get-rfp-categories`, payload);
  } catch (error) {
    throw error;
  }
};

export const getAllTitles = async (payload: any) => {
  try {
    return await axiosInstance.post(`event/get-all-titles`, payload);
  } catch (error) {
    throw error;
  }
};